import React from 'react';

const Facebook = () => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#0F161E"
        d="M19.857 2H4.143A2.143 2.143 0 002 4.143v15.714A2.143 2.143 0 004.143 22h6.127v-6.8H7.458V12h2.812V9.56c0-2.774 1.652-4.306 4.182-4.306 1.211 0 2.478.216 2.478.216v2.723h-1.396c-1.375 0-1.804.853-1.804 1.729V12h3.07l-.49 3.2h-2.58V22h6.127A2.143 2.143 0 0022 19.857V4.143A2.143 2.143 0 0019.857 2z"
       />
    </svg>
);

export default Facebook;
